export default class SDRateGainWorksheet {
  l7 = (): number | undefined => undefined
}
